import React from "react";
export var useImageUpload = function (initial) {
    var _a = React.useState(initial.file), file = _a[0], setFile = _a[1];
    var _b = React.useState(initial.image), image = _b[0], setImage = _b[1];
    React.useEffect(function () {
        if (file) {
            var reader_1 = new FileReader();
            reader_1.addEventListener("loadend", function () { return setImage(reader_1.result); });
            reader_1.readAsDataURL(file);
        }
    }, [file]);
    var onImageChange = function (evt) {
        var files = evt.target.files;
        if (files && files.length > 0) {
            setFile(files[0]);
        }
        else {
            setFile(null);
        }
    };
    var resetImage = function () { return setImage(null); };
    var resetFile = function () { return setFile(null); };
    return {
        image: image,
        onImageChange: onImageChange,
        resetImage: resetImage,
        resetFile: resetFile,
        setImage: setImage,
        file: file,
    };
};
